import { config } from '@/config'

export default {
	items(state, getters) {
		return getters["cart/items"]
	},
	brands(state) {
		return state.brands;
	},
	initialized(state) {
		return state.initialized;
	},
	shopArea(state) {
		return state.shopArea;
	},
	shopArea(state) {
		return state.shopArea;
	}
}
